import { useEffect } from 'react'
import { useLDClient } from 'launchdarkly-react-client-sdk'
import { ldContext } from '@/config/launchdarkly'
import { useAuthStore } from '@/stores/authStore'
import { TENANT_ID } from '@/config/tenant'

/**
 * Keeps the LaunchDarkly context in sync with the authenticated user.
 *
 * - Logged in  → identifies with tenant + user email (named session in LD Observability)
 * - Logged out → reverts to anonymous user context
 *
 * Call this once at the top of App so it runs for every route.
 */
export function useLDIdentify() {
  const ldClient = useLDClient()
  const user = useAuthStore(s => s.user)

  useEffect(() => {
    if (!ldClient) return
    ldClient.identify(ldContext(TENANT_ID, user?.email ?? undefined))
  }, [ldClient, user?.email])
}
